import { Dropdown } from "primereact/dropdown";
import React, { useState } from "react";
import { downloadFile } from "../../../Services/GlobalService";
import { toast } from "react-toastify";
import * as Fa from "react-icons/fa";

// ── Quarter helpers ────────────────────────────────────────────────────────────
function nextQuarter(): string {
  const now = new Date();
  const year = now.getFullYear();
  const q = Math.ceil((now.getMonth() + 1) / 3);
  return q === 4 ? `${year + 1}1` : `${year}${q + 1}`;
}

function buildQuarterOptions(): { label: string; value: string }[] {
  const now = new Date();
  const year = now.getFullYear();
  const opts: { label: string; value: string }[] = [];
  for (const y of [year - 1, year, year + 1]) {
    for (let q = 1; q <= 4; q++) {
      opts.push({ label: `${y}(Q${q})`, value: `${y}${q}` });
    }
  }
  return opts.sort((a, b) => Number(b.value) - Number(a.value));
}

const QUARTER_OPTIONS = buildQuarterOptions();

// ── Component ──────────────────────────────────────────────────────────────────
const RNRPayoutReport = () => {
  const Controller = "RNR/RewardsRebateStatusReport";

  // ── State ──────────────────────────────────────────────────────────────────
  const [selectedQuarter, setSelectedQuarter] = useState<string>(nextQuarter());
  const [downloading, setDownloading] = useState(false);

  // ── Download ────────────────────────────────────────────────────────────────
  const handleDownload = async () => {
    if (!selectedQuarter) {
      toast.info("Please select a quarter first.");
      return;
    }
    setDownloading(true);
    try {
      const filename = `RNR_Payout_Report_${selectedQuarter}.xlsx`;
      await downloadFile(
        Controller,
        "DownloadReportPayout",
        `qtrId=${selectedQuarter}`,
        filename
      );
      toast.success("Report downloaded successfully.");
    } catch (error: any) {
      toast.error(error?.response?.data?.message ?? "No data found for the selected quarter.");
    } finally {
      setDownloading(false);
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <main>
      <div className="col-12 mb-5">
        <div className="row">
          {/* Breadcrumb  */}
          <div className="col-lg-12 col-md-12 col-sm-12">
            <nav aria-label="breadcrumb" className="drop-in">
              <ol className="breadcrumb mx-0">
                <li className="breadcrumb-item">Rewards &amp; Rebate</li>
                <li className="breadcrumb-item active" aria-current="page">
                  R&amp;R Payout Report
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h3 className="py-2">R&amp;R Payout Report</h3>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12"></div>
        </div>

        <section className="sales-box">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-4 col-md-12 col-sm-12">
                <form>
                  <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                    <div className="d-block">
                      <label className="form-label">
                        Year &amp; Quarter <span className="text-danger">*</span>
                      </label>
                      <Dropdown
                        value={selectedQuarter}
                        onChange={(e) => setSelectedQuarter(e.value)}
                        options={QUARTER_OPTIONS}
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Quarter"
                        className="w-full"
                      />
                    </div>
                  </div>

                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="text-end mt-3">
                      <button
                        type="button"
                        className="btn anime-btn"
                        onClick={handleDownload}
                        disabled={downloading}
                      >
                        {downloading ? "Downloading…" : "Download as Excel"} <Fa.FaDownload className="ms-2" />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="text-end">
                  <img 
                    src={require("../../../Assets/Images/data_report.png")} 
                    className="Side_Img drop-right" 
                    alt="Report" 
                  />
                </div>
              </div>
            </div>
        </section>
      </div>
    </main>
  );
};

export default RNRPayoutReport;
